var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pagination-tableau mt-2" },
    [
      _vm.rows
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { lg: "6" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { disabled: _vm.disabledFirst },
                      on: { click: _vm.onPrevious },
                    },
                    [
                      _c("i", { staticClass: "mdi mdi-page-first" }),
                      _vm._v("Prev"),
                    ]
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-1",
                      attrs: { disabled: _vm.disabledLast },
                      on: { click: _vm.onNext },
                    },
                    [
                      _vm._v("Next"),
                      _c("i", { staticClass: "mdi mdi-arrow-right" }),
                    ]
                  ),
                ],
                1
              ),
              _c("b-col", { attrs: { lg: "6" } }, [
                _c("div", { staticClass: "text-right mt-2" }, [
                  _vm.rows
                    ? _c("p", [
                        _vm._v(
                          "Page " +
                            _vm._s(_vm.page) +
                            " of " +
                            _vm._s(_vm.totalPage) +
                            " - Total records " +
                            _vm._s(_vm.rows)
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }